import React, { useState } from 'react'

import AnimateHeight from 'react-animate-height'
import { CheckBox, IconBottom } from 'shared/components'
import { useQuery, useTypedSelector } from 'shared/hooks'
import { stringToArray } from 'shared/utils'

import { formatsOptions } from '../consts'
import classes from './Filters.module.scss'

type path = 'filterFormat' | 'filterGenre'

type Props = {
  useLocalQuery?: boolean
  localQuery?: { [key: string]: string }
  setLocalQuery?: (value: { [key: string]: string }) => void
  setIsMore: (m: boolean) => void
}

export const CatalogFilters: React.FC<Props> = ({
  useLocalQuery = false,
  localQuery = {},
  setLocalQuery = () => {},
  setIsMore,
}): JSX.Element => {
  const [globalQuery, setGlobalQuery] = useQuery()
  const [isOpen, setIsOpen] = useState(false)
  const query = useLocalQuery ? localQuery : globalQuery
  const setQuery = useLocalQuery ? setLocalQuery : setGlobalQuery
  const { genres } = useTypedSelector(state => state.catalog)

  const findElementIndex = (path: path, value: string): number | null => {
    const currentArray: string[] = stringToArray(query?.[path]) || []
    const index = currentArray?.findIndex(v => v === value)
    return index === -1 ? null : index
  }

  const onChange = (path: path, value: string, index: number | null) => {
    const currentArray: string[] = stringToArray(query?.[path]) || []

    setIsMore(false)

    if (index !== null) {
      currentArray.splice(index, 1)
      setQuery({ ...query, [path]: `${currentArray}`, page: '1' })
    } else {
      const array = `${[...currentArray, value]}`
      setQuery({ ...query, [path]: array, page: '1' })
    }
  }

  const renderCheckbox = (
    item: { title: string; value: string },
    index: number,
    path: path
  ): JSX.Element => {
    const elIndex = findElementIndex(path, item.value)
    return (
      <CheckBox
        checked={elIndex !== null}
        key={index}
        readOnly
        onClick={() => onChange(path, item.value, elIndex)}
      >
        {item.title}
      </CheckBox>
    )
  }

  const renderGenres = () => {
    return (
      <>
        {genres[0]?.length > 0 && (
          <>
            <span className={classes.block_title}>Жанр</span>
            {genres[0].map((genre, genreIndex) =>
              renderCheckbox(genre, genreIndex, 'filterGenre')
            )}
          </>
        )}
        {genres[1]?.length > 0 && (
          <>
            <AnimateHeight height={isOpen ? 'auto' : 0} duration={200}>
              <div className={classes.block}>
                {genres[1].map((genre, genreIndex) =>
                  renderCheckbox(genre, genreIndex, 'filterGenre')
                )}
              </div>
            </AnimateHeight>
            <span className="link color" onClick={() => setIsOpen(p => !p)}>
              {
                <IconBottom
                  isOpen={isOpen}
                  openText={`Еще ${genres[1]?.length}`}
                  closeText={`Скрыть`}
                />
              }
            </span>
          </>
        )}
      </>
    )
  }

  return (
    <div className={classes.container}>
      <div className={classes.block}>
        <span className={classes.block_title}>Формат</span>
        {formatsOptions.map((format, formatIndex) =>
          renderCheckbox(format, formatIndex, 'filterFormat')
        )}
      </div>

      <div className={classes.block}>
        {renderGenres()}
        <span className="link color" onClick={() => setQuery({})}>
          Сбросить все
        </span>
      </div>
    </div>
  )
}
